import { useState, useEffect } from 'react';

import { COMPONENT_CALLER_TYPE } from 'commons/constants';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import useProductBasicDetails from '../useProductBasicDetails';
import useClearanceData from '../useClearanceData';

const useProductLabel = (id, slug, hookOptions = {}) => {
  const [productLabel, setProductLabel] = useState(null);
  const { productSku } = hookOptions;

  const {
    loading: basicLoading,
    error: basicError,
    data: basicData,
  } = useProductBasicDetails(id, slug, {
    skipPDPStateHook: false,
    productSku,
  });

  const productOptionData = usePDPOptions();

  const {
    loading: optionsLoading,
    error: optionsError,
    data: optionsData,
  } = productOptionData;

  const {
    error: clearanceDataError,
    data: clearanceData,
  } = useClearanceData(id, slug, { callerType: COMPONENT_CALLER_TYPE.PDP });

  const { isClearance } = clearanceData;

  useEffect(() => {
    let label = null;
    // lowest priority is 'Low Stock'
    if (
      optionsData?.stock?.isSelectedOptionsQuickship &&
      optionsData.stock.selectedOptionsStockQty <= 3
    ) {
      label = 'Low Stock';
    }
    // higher priority is 'Clearance'
    if (isClearance) {
      label = 'Final Sale';
    }
    // highest priority is `product_label` Custom Property
    if (basicData?.custom_properties?.product_label?.[0]) {
      const [itemLabel] = basicData.custom_properties.product_label;
      label = itemLabel;
    }
    if (label !== productLabel) {
      setProductLabel(label);
    }
  }, [basicData, clearanceData, isClearance, optionsData, productLabel]);

  return {
    loading: basicLoading || optionsLoading,
    error: basicError || optionsError || clearanceDataError,
    data: {
      productLabel,
    },
  };
};

export default useProductLabel;
